
export type UpdateUser401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
